import axios from 'axios'

const ENDPOINTS = {
    'PRODUCT': '/products/[REPLACE]/images.js',
    'PRODUCT_IMAGES': '/products/[REPLACE]/images.js',
    'RECOMMENDATIONS': '/recommendations/products.json?product_id=[ID]&limit=[LIMIT]'
}

class AjaxAPI {
    static async getProduct (handle) {
        let product = await axios.get(`${ENDPOINTS.PRODUCT.replace('[REPLACE]', handle)}`)
        return product
    }

    static async getCartImages (cartItems) {
        const requestArray = []
        const getCartImagesObject = {}

        cartItems.forEach((item) => {
            requestArray.push(axios.get(`${ENDPOINTS.PRODUCT.replace('[REPLACE]', item.handle)}`))
        })

        const responses = await axios.all(requestArray)

        responses.forEach((response) => {
            getCartImagesObject[response.data.handle] = response.data.media
        })

        return getCartImagesObject
    }

    static async getProductRecommendations (id, limit) {
        const recommendations = await axios.get(`${ENDPOINTS.RECOMMENDATIONS.replace('[ID]', id).replace('[LIMIT]', limit)}`)
        return recommendations
    }

    static getLineCount (cart) {
        return cart.items.length
    }

    static _rand () {
        return Math.floor(100000000 + Math.random() * 900000000)
    }
}

export default AjaxAPI



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/AjaxAPI.js